import { render, staticRenderFns } from "./confirm-installed-modal.vue?vue&type=template&id=0f4f5021"
import script from "./confirm-installed-modal.vue?vue&type=script&lang=js"
export * from "./confirm-installed-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports